import TimelineHorizontal from 'components/timeline-horizontal/TimelineHorizontal';

import { ITimelineHorizontalBlock } from 'source/NFR.types';

const TimelineHorizontalBlock: React.FC<ITimelineHorizontalBlock> = props => (
  <TimelineHorizontal
    numberOfSlidesToShow={{
      '0px': 1,
      '510px': 2,
      '768px': 3
    }}
    theme="block"
    {...props}
  />
);

TimelineHorizontalBlock.displayName = 'TimelineHorizontalBlock';

export default TimelineHorizontalBlock;
